<template>
  
    <div  class="max-w-7xl mx-auto sm:px-6 lg:px-8">
      <div id="dataPanel" class="bg-white overflow-hidden px-3 shadow-xl sm:rounded-lg">
        <div class="row pt-3 px-2">
            <div class="col">
                <jet-button class="bg-blue-500 text-white hover:bg-blue-500  hover:no-underline px-2 cursor-pointer  text-sm" @click="back">Back</jet-button>
  
                <jet-button @click="editItem"  class="btn-suspend px-2  hover:no-underline cursor-pointer btn-suspend-container text-sm"  > Edit </jet-button> &nbsp;
                <jet-button  @click="deleteItem" class="btn-delete px-2   cursor-pointer text-sm ">
                        Delete
                </jet-button>
            </div>
        </div>


        <form class="p-2 mt-2" >
          <BsShowForm
            :createDef="detailDef"
            :routeDef="moduleRoute"
            :modelData="modelData1"

          >
          </BsShowForm>

          <!-- <input class="mt-2 bg-blue-500 text-xs" type="submit" value="Submit" /> -->
        </form>

        <div class="pt-2">
          <DxTabPanel>
            <DxItem
              v-for="(data,key) in relationData"
              icon="fields"
              :title="data['rmodule']"
              :key="data['rmodule']"
            >
              <div class="px-2" >
                {{ data['rmodule'] }}
                <DetailPanel :slug="slug" :routeDef="data['route']" :relationDef="data" :parentId="this.modelData1.id" :parentRoute="this.moduleRoute" >

                </DetailPanel>
              </div>


            </DxItem>
 
          </DxTabPanel>
        </div>

      </div>


    <DxToast
      v-model:visible="isVisible"
      v-model:message="message"
      v-model:type="type"
     />
   
    
    </div>

</template>
<script>


/* from Include */
import DetailPanel from '@include/pages/DetailViewPanel.vue';
import BsShowForm from '@include/forms/BsShowForm.vue';
//need to move to include
import Test from '@/components/ProgressBarComponent.vue';
/* from Devextreme */
import DxTabPanel, { DxItem } from "devextreme-vue/tab-panel";
import DxDataGrid from "devextreme-vue/data-grid";
import { DxToast } from 'devextreme-vue/toast';
import { confirm, alert } from 'devextreme/ui/dialog';
/* default laravel Jetstream */
import JetNavLink from '@/Jetstream/NavLink.vue'
import JetButton from "@/Jetstream/Button.vue";

export default {
        props: {
            detailDef:{
                type: Array,
                default: []
            },
            moduleRoute:String,
            modelData:{
                type: Object,
                default: () => ({})
            },
            c :{
                type: Array,
                default: []
            },
            route:"",
            slug:String
        },
        components: {
          BsShowForm,          
          DxTabPanel,
          DxItem,
          Test,
          DxDataGrid,
          JetNavLink,
          JetButton,
          DxToast,
          DetailPanel,
        
    },
    data: function() {

        return {
            title:_.startCase(this.moduleRoute),
            modelData1:this.modelData,

            form: this.$inertia.form(),
            isVisible: false,
            message: '',
            type: 'success',
              
        }
    },
     created() {
      console.log("BASE SHOW SLUG",this.slug);
     },    
    methods: {
       showToast(message,type)
        {
          this.isVisible = true;
          this.message = message;
          this.type = type;
        },

        deleteItem() {
              let result = confirm("<i>Are you sure?</i>", "Confirm changes");
                    result.then((dialogResult) => {
                     
                     if(dialogResult)
                        {
                            this.form.delete(route(this.moduleRoute+'.destroy', this.modelData.id), {
                                errorBag: 'deleteIteam',
                                onSuccess:this.showToast('Successfully Deleted','success'),
                                
                            });
                        }
                    });

        },
        editItem() {
           
            this.form.get(route(this.moduleRoute+'.edit', this.modelData.id), {
                errorBag: 'UpdateItem',
            });
        },
        back() {
            this.$inertia.get('/'+this.moduleRoute);
        },

        hello(){
            alert('hello');
        },
        showLoadPanel() {  
          this.loadingVisible = true;
        },
        onShown() {
          setTimeout(() => {
            this.loadingVisible = false;
          }, 3000);
        },
        onHidden() {
          alert("hello qt3.14 ");
          
        },
       
    },

    mounted() {

      console.log("relationData",this.relationData);
      console.log("modelData",this.modelData);
      console.log("moduleRoute",this.moduleRoute);


    },
    
}


</script>

 <style>
/* This is added because the settings icon was moving up - START */

.manage-margin-in-detail {
  margin-top: 4px;
}

/* This is added because the settings icon was moving up - START */

/*Panel tabs*/
#tab-contents {
  margin: 0 auto;
}

.detail,
.details-tabs-container {
  background-color: var(--white);
  border: 1px solid #ebebeb;
}

.setting-icon-margin-manage {
  margin-top: 0.6px;
}

a {
  text-decoration: none !important;
}

a:hover {
  color: #000;
}
.nav-panel-heading {
  margin-top: 10px;
}

.detail-heading {
  border-bottom: 1px solid var(--input_grey);
  padding: 2px;
}

.tabs {
  padding: 0;
  display: flex;
  border-bottom: 1px solid var(--input_grey);
  color: var(--text_grey);
}

.detail-tabs {
  margin: 0px 0px 0px 0px !important;
}

.tabs li {
  position: relative;
  background-color: var(--white);
  cursor: pointer;
  font-weight: normal;
  margin: 0px 0px 0px 0px !important;
  padding: 5px 20px !important;
  border-radius: 0px !important;
  list-style-type: none;
}

.tabs li.active {
  border-bottom: 2px solid var(--blue);
  color: #333;
  font-weight: bold;
}

.tabs li::before {
  content: "";
  visibility: hidden;
  width: 0;
  height: 2px;
  border-bottom: 1px solid var(--blue);
  background-color: var(--blue);
}

.tabs li:hover {
  background-color: #c6e3ff;
  color: var(--blue);
  font-weight: bold;
}

.tabs li:hover::before {
  visibility: visible;
  bottom: 0;
  width: 100%;
}

.panel {
  display: none;
  background: var(--white);
  box-shadow: 0 0 0 0 transparent;
  padding: 0 15px;
}

.panel.active {
  display: block;
}

.heading-row-margins {
  margin-left: 13px;
}

.breadcrumb-margin {
  margin-right: -8px;
}

.btn-back {
  background-color: var(--blue) !important;
  color: var(--white);
  padding-top: 1px !important;
}

a {
  text-decoration: none !important;
}

a:hover {
  color: #000;
}

.btn-suspend {
  background-color: var(--orange) !important;
  color: var(--white);
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 2px;
  padding-bottom: 2px;
}

btn-suspend:hover {
  color: #fff;
  background-color: #5a6268 !important;
}

.btn-up {
  background-color: var(--blue) !important;
  color: var(--white);
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 2px;
  margin-right: 5px;
  padding-bottom: 2px;
}

btn-up:hover {
  color: #000;
}

.btn-delete {
  background-color: var(--red) !important;
  color: var(--white);
  padding-left: 20px;
  padding-right: 20px;
  margin-right: 5px;

}

.btn-delete:hover {
  color: #000;
}

.btn-delete-container {
  position: absolute;
  right: 10px;
  
  margin-top: -25px;
}

.btn-suspend-container {
  position: absolute;
  right: 120px;
}
</style>